import { makeFactories } from '../ViewProperty';

import * as Model from 'models/autosrc/swivell/talent_marketplace';
import { Views } from '@pitaman71/omniglot-live-react';

export const { Edit, View} = makeFactories(['roles', 'hasRates'], Model.Roles.HasRate.Descriptor);
Views.All.push(Edit, View);

